import { ReactNode } from "react";

import { Header } from "../Header";
import { Sidebar } from "../Sidebar";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <div className="ml-32">
        <Header />
        <main className="ml-32 pt-16">
          <div className="container mx-auto px-6 py-8">{children}</div>
        </main>
      </div>
    </div>
  );
}
